import React, { Component } from "react";
import ReactDOM from "react-dom";

import "./styles.css";


class SignInForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {
        accountWwex: "",
        accountUni: "",
        nameWwexUni: ""
      },
      isSubmitting: false,
      isError: false
    };
  }



  submitForm = async e => {
    e.preventDefault();
    console.log(this.state);
    this.setState({ isSubmitting: true });

      const res = await fetch("https://yiofi05n66.execute-api.us-west-2.amazonaws.com/Prod/check/", {
      //const res = await fetch("http://127.0.0.1:3001/check", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(this.state.values),
      headers: {
        "Accept": "*/*",
        "Origin": "https://check.wwex.com/",
        "Content-Type": "text/plain",
        //"x-api-key": "dxG7CWlDks7fVrtI3pM5X7TzcmaLSooL1ijduq8J",
      }
    })

    this.setState({ isSubmitting: false });


    const data = await res.text();
    const jsonData = JSON.parse(data)


    var dispResponse = [ jsonData.version, jsonData.name, jsonData.url, jsonData.accountData ]



    if (!jsonData.hasOwnProperty("error")) {

      if (!jsonData.hasOwnProperty("accountData")) {
        this.setState({ message: 'success', dataDisp: dispResponse })
      } else {
            const accountJSON = jsonData["accountData"]
            const JSONaccount = JSON.parse(accountJSON)

            const collectionJSON = JSONaccount["collection"]
            //console.log(collectionJSON[0])
            this.setState({ message: 'successAccount', dataKey: collectionJSON  })
      }


    } else {

      this.setState({ message: 'error', isError: true })

    }
  };

  handleInputChange = e =>
    this.setState({
      values: { ...this.state.values, [e.target.name]: e.target.value }
    });

  render() {

    
    
    return (
      <div>
        <form onSubmit={this.submitForm}>
          <div className="input-group">
            <label htmlFor="accountWwex">WWEX Account Number</label>
            <input
              type="text"
              name="accountWwex"
              id="accountWwex"
              value={this.state.values.accountWwex}
              onChange={this.handleInputChange}
              title="accountWwex"
              
            />
          </div>


          <div className="input-group">
            <label htmlFor="accountUni">Unishippers Account Number</label>
            <input
              type="text"
              name="accountUni"
              id="accountUni"
              value={this.state.values.accountUni}
              onChange={this.handleInputChange}
              title="accountUni"
              
            />
                        <br /><br /><br /><br /><br /><br />

          </div>


          <div className="input-group">
            <label htmlFor="nameWwexUni">Search for Account Name</label>
            <input
              type="text"
              name="nameWwexUni"
              id="nameWwexUni"
              value={this.state.values.nameWwexUni}
              onChange={this.handleInputChange}
              title="nameWwexUni"
              
            />
          </div>



          <button type="submit">Check</button>

        </form>
        <div className={`message ${this.state.isError && "error"}`}>
          {this.state.isSubmitting ? "Submitting..." : ""}

          {this.state.message === 'success' && this.state.dataDisp[0] === 'V0' && (

                <p>This account was found in the OLD version of Salesforce. Please click on the link below to view:<br/>
                <a href={this.state.dataDisp[2]} target="_blank" rel="noreferrer">{this.state.dataDisp[1]}</a><br/><br/>
                <a href="http://check.wwex.com/">Refresh component</a>
            </p>
          )}

          {this.state.message === 'success' && this.state.dataDisp[0] === 'V1' && (

                <p>This account was found in the NEW version of Salesforce. Please click on the link below to view:<br/>
                <a href={this.state.dataDisp[2]} target="_blank" rel="noreferrer">{this.state.dataDisp[1]}</a><br/><br/>
                <a href="http://check.wwex.com/">Refresh component</a>
            </p>
          )}

          {this.state.message === 'successAccount' && (

                <div>Account name search results: 
                  <br/><br/>
                  <ul>
                    {this.state.dataKey.map(item => {
                        return (
                          <>
                          {item.version === 'V0' && (
                            <div key={item.counter}><li id={item.counter} key={item.counter} align="start">This account was found in OLD Salesforce: <a href={item.url} target="_blank" rel="noreferrer">{item.name}</a></li></div>
                          )}


                          {item.version === 'V1' && (
                            <div key={item.counter}><li id={item.counter} key={item.counter} align="start">This account was found in NEW Salesforce: <a href={item.url}  target="_blank" rel="noreferrer">{item.name}</a></li></div>
                          )}
                          </>

                        )
                      } 
                    )}
                  </ul>
                  <br/><br/>
                       


                  <br/><br/>
                <a href="http://check.wwex.com/">Refresh component</a>
            </div>
          )}
          

          













          {this.state.message === 'error' && (
                <p>We could not locate this account in either version of Salesforce. Please verify the account and try again.<br/><br/>
                <a href="http://check.wwex.com.s3-website-us-west-2.amazonaws.com/">Refresh component</a>
            </p>
          )}
          
        </div>


      </div>

      
    );
  }
}



function App() {
  return (
    <div className="App">
      <h1>WWEX / UNI Account Check</h1>
      <SignInForm />
    </div>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);